module.exports = {"110108001":"万寿路街道","110108002":"永定路街道","110108003":"羊坊店街道","110108004":"甘家口街道","110108005":"八里庄街道","110108006":"紫竹院街道","110108007":"北下关街道","110108008":"北太平庄街道","110108010":"学院路街道","110108011":"中关村街道","110108012":"海淀街道","110108013":"青龙桥街道","110108014":"清华园街道","110108015":"燕园街道","110108016":"香山街道","110108017":"清河街道","110108018":"花园路街道","110108019":"西三旗街道","110108020":"马连洼街道","110108021":"田村路街道","110108022":"上地街道","110108023":"万柳地区","110108024":"东升地区","110108025":"曙光街道","110108026":"温泉地区","110108027":"四季青地区","110108028":"西北旺地区","110108029":"苏家坨地区","110108030":"上庄地区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110108.json
// module id = 27
// module chunks = 0